// extracted by mini-css-extract-plugin
export default {"btn":"PrimaryButton_btn__gGSK0","btnStrong":"PrimaryButton_btnStrong__XVoEd","btnWeak":"PrimaryButton_btnWeak__ETgKH"};